"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isIOS_1 = __importDefault(require("../utils/isIOS"));

function Clipboard(window, document, navigator) {
  function createTextArea(text) {
    var textArea = document.createElement('textArea');
    textArea.value = text;
    document.body.appendChild(textArea);
    return textArea;
  }

  function selectText(textArea) {
    if (isIOS_1.default(navigator)) {
      var range = document.createRange();
      range.selectNodeContents(textArea);
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }

    return textArea;
  }

  function copy(text) {
    var textArea = selectText(createTextArea(text));
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }

  return {
    copy: copy
  };
}

exports.default = Clipboard;